import styled from 'styled-components';

export const AbandonedCartAnchor = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const AbandonedCartCard = styled.div`
  position: absolute;
  top: 56px;
  right: 0;
  width: 416px;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grayAntdBorder};
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 16px;
  z-index: 999;

  padding-top: 16px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  gap: 16px;

  &::before {
    content: '';
    position: absolute;
    top: -8px;
    right: 16px;
    width: 14px;
    height: 14px;
    background: ${(props) => props.theme.colors.white};
    border-left: 1px solid ${(props) => props.theme.colors.grayAntdBorder};
    border-top: 1px solid ${(props) => props.theme.colors.grayAntdBorder};
    transform: rotate(45deg);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const CardTitle = styled.span`
  font-weight: 400;
  font-size: 20px;
  color: ${(props) => props.theme.colors.grayDark6};
  font-family: 'Source Sans 3', 'Source Sans Pro', Arial, Helvetica, sans-serif;
  line-height: 28px;
`;

export const ReminderBadge = styled.span`
  display: inline-block;
  font-size: 11px;
  color: ${(props) => props.theme.colors.graySubTitle};
  margin-bottom: 12px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  color: ${(props) => props.theme.colors.grayDark6};
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  margin-left: 8px;

  > span {
    font-size: 14px;
  }

  &:hover {
    color: ${(props) => props.theme.colors.grayDark5};
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.red2};
    outline-offset: 2px;
    border-radius: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PartnerBlock = styled.div`
  margin-bottom: 8px;

  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PartnerLabel = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Source Sans 3', 'Source Sans Pro', Arial, Helvetica, sans-serif;
  line-height: 24px;
  color: ${(props) => props.theme.colors.grayDark6};
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
  margin-bottom: 2px;
`;

export const PartnerAddress = styled.span`
  display: block;
  font-size: 14px;
  color: ${(props) => props.theme.colors.grayDark6};
  font-family: ${({ theme }) => theme.fonts.workSans};
  line-height: 22px;
`;

export const ProductBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const ProductImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 4px;
`;

export const ProductInfo = styled.div`
  flex: 1;
  min-width: 0;
  line-height: 24px;
`;

export const ProductName = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.grayDark6};
  font-family: ${({ theme }) => theme.fonts.workSans};
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProductExtra = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.grayDark6};
  font-family: ${({ theme }) => theme.fonts.workSans};
  margin-top: 2px;
`;
